import React from "react";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Squash as Hamburger } from "hamburger-react";
import SocialIcons from "../UI/IconsComponents/SocialIcons";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function MenuCollapse() {
  const [rootExpanded, setRootExpanded] = React.useState(false);
  const { t } = useTranslation(); // Usa il hook useTranslation
  const location = useLocation();
  const isRoomPage = location.pathname.startsWith("/rooms/");
  const navigationLinks = [
    {
      text: t("home"),
      link: "/",
    },
    {
      text: t("rooms"),
      link: "/rooms",
    },
    {
      text: t("booking"),
      link: "/booking",
    },
    {
      text: t("location"),
      link: "/location",
    },
    {
      text: t("contact"),
      link: "/raggiungici",
    },
  ];

  return (
    <Box
      sx={{
        pointerEvents: "auto",
        zIndex: 1500,
      }}
      onClick={() => setRootExpanded(!rootExpanded)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          cursor: "pointer",
          backgroundColor: isRoomPage ? "#1c3337" : "white",
        }}
      >
        <Typography
          variant={"body2"}
          sx={{
            color: isRoomPage ? "white" : "#1c3337",
            fontWeight: 500,
            fontSize: "18px",
            display: "block",
          }}
        >
          {t("menu")} {/* Traduci il testo del menu */}
        </Typography>
        <Hamburger
          size={16}
          hideOutline={false}
          duration={0.8}
          color={isRoomPage ? "white" : "#1c3337"}
          toggled={rootExpanded}
        />
      </Box>

      <Collapse in={rootExpanded}>
        <Stack
          spacing={3}
          width={"100%"}
          alignItems={"center"}
          sx={{
            backgroundColor: "white",
          }}
        >
          {navigationLinks.map((link, index) => (
            <Link
              key={index}
              to={link.link}
              style={{
                textDecoration: "none",
                width: "100%",
                marginTop: 0,
                padding: 4,
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  p: 0,
                  pb: 0.2,
                  marginTop: 0,
                  fontWeight: 500,
                  letterSpacing: 2,
                  borderBottom: "0.1px solid #33414Cc9",
                  textTransform: "uppercase",
                  fontFamily: "degular",
                }}
                variant={"body1"}
              >
                {link.text} {/* Traduci il testo del link */}
              </Typography>
            </Link>
          ))}
        </Stack>{" "}
        <Stack
          sx={{ paddingBottom: 3, backgroundColor: "white" }}
          width={"100vw"}
          alignItems={"center"}
        >
          <SocialIcons isRow />
        </Stack>
      </Collapse>
    </Box>
  );
}

export default MenuCollapse;
